export const CalenderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99976 12C1.99976 8.22876 1.99976 6.34315 3.17133 5.17157C4.3429 4 6.22852 4 9.99976 4H13.9998C17.771 4 19.6566 4 20.8282 5.17157C21.9998 6.34315 21.9998 8.22876 21.9998 12V14C21.9998 17.7712 21.9998 19.6569 20.8282 20.8284C19.6566 22 17.771 22 13.9998 22H9.99976C6.22852 22 4.3429 22 3.17133 20.8284C1.99976 19.6569 1.99976 17.7712 1.99976 14V12Z"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
      <path
        d="M6.99976 4V2.5"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.9998 4V2.5"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.49976 9H21.4998"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.9998 17C17.9998 17.5523 17.552 18 16.9998 18C16.4475 18 15.9998 17.5523 15.9998 17C15.9998 16.4477 16.4475 16 16.9998 16C17.552 16 17.9998 16.4477 17.9998 17Z"
        fill="#284CB1"
      />
      <path
        d="M17.9998 13C17.9998 13.5523 17.552 14 16.9998 14C16.4475 14 15.9998 13.5523 15.9998 13C15.9998 12.4477 16.4475 12 16.9998 12C17.552 12 17.9998 12.4477 17.9998 13Z"
        fill="#284CB1"
      />
      <path
        d="M12.9998 17C12.9998 17.5523 12.552 18 11.9998 18C11.4475 18 10.9998 17.5523 10.9998 17C10.9998 16.4477 11.4475 16 11.9998 16C12.552 16 12.9998 16.4477 12.9998 17Z"
        fill="#284CB1"
      />
      <path
        d="M12.9998 13C12.9998 13.5523 12.552 14 11.9998 14C11.4475 14 10.9998 13.5523 10.9998 13C10.9998 12.4477 11.4475 12 11.9998 12C12.552 12 12.9998 12.4477 12.9998 13Z"
        fill="#284CB1"
      />
      <path
        d="M7.99976 17C7.99976 17.5523 7.55204 18 6.99976 18C6.44747 18 5.99976 17.5523 5.99976 17C5.99976 16.4477 6.44747 16 6.99976 16C7.55204 16 7.99976 16.4477 7.99976 17Z"
        fill="#284CB1"
      />
      <path
        d="M7.99976 13C7.99976 13.5523 7.55204 14 6.99976 14C6.44747 14 5.99976 13.5523 5.99976 13C5.99976 12.4477 6.44747 12 6.99976 12C7.55204 12 7.99976 12.4477 7.99976 13Z"
        fill="#284CB1"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99976 10.1433C3.99976 5.64588 7.58148 2 11.9998 2C16.418 2 19.9998 5.64588 19.9998 10.1433C19.9998 14.6055 17.4464 19.8124 13.4627 21.6744C12.534 22.1085 11.4655 22.1085 10.5368 21.6744C6.55308 19.8124 3.99976 14.6055 3.99976 10.1433Z"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
      <circle cx="11.9998" cy="10" r="3" stroke="#284CB1" strokeWidth="1.5" />
    </svg>
  );
};

export const MedicBoxIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7083 21.7926C21.7083 20.5269 22.7343 19.5009 24 19.5009C25.2657 19.5009 26.2917 20.5269 26.2917 21.7926C26.2917 23.0582 25.2657 24.0842 24 24.0842C22.7343 24.0842 21.7083 23.0582 21.7083 21.7926ZM24 20.7509C23.4247 20.7509 22.9583 21.2173 22.9583 21.7926C22.9583 22.3679 23.4247 22.8342 24 22.8342C24.5753 22.8342 25.0417 22.3679 25.0417 21.7926C25.0417 21.2173 24.5753 20.7509 24 20.7509Z"
        fill="#284CB1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 24.5009C23.0035 24.5009 22.0705 24.7015 21.3635 25.055C20.6938 25.3899 20.0417 25.9681 20.0417 26.7926L20.0416 26.8446C20.0403 27.2699 20.0381 27.986 20.7169 28.4774C21.0318 28.7053 21.4474 28.8507 21.9622 28.9434C22.4818 29.0369 23.1477 29.0842 24 29.0842C24.8523 29.0842 25.5182 29.0369 26.0378 28.9434C26.5526 28.8507 26.9682 28.7053 27.2831 28.4774C27.9619 27.986 27.9597 27.2699 27.9584 26.8446L27.9583 26.7926C27.9583 25.9681 27.3062 25.3899 26.6365 25.055C25.9295 24.7015 24.9965 24.5009 24 24.5009ZM21.2917 26.7926C21.2917 26.6966 21.3857 26.4415 21.9225 26.1731C22.4219 25.9234 23.1555 25.7509 24 25.7509C24.8445 25.7509 25.5781 25.9234 26.0775 26.1731C26.6143 26.4415 26.7083 26.6966 26.7083 26.7926C26.7083 27.2963 26.6763 27.3735 26.5502 27.4648C26.4485 27.5384 26.2391 27.6371 25.8164 27.7131C25.3985 27.7883 24.8143 27.8342 24 27.8342C23.1857 27.8342 22.6015 27.7883 22.1836 27.7131C21.7609 27.6371 21.5515 27.5384 21.4498 27.4648C21.3237 27.3735 21.2917 27.2963 21.2917 26.7926Z"
        fill="#284CB1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2695 16.0018C22.4728 15.5897 23.2187 15.3342 24 15.3342C24.7813 15.3342 25.5272 15.5897 26.7305 16.0018L27.3367 16.2093C28.5711 16.6319 29.5238 16.958 30.2058 17.235C30.5493 17.3746 30.8447 17.5098 31.0825 17.6479C31.3114 17.7808 31.541 17.9466 31.697 18.1688C31.8512 18.3885 31.9309 18.6586 31.981 18.9186C32.0331 19.1889 32.0645 19.5131 32.0847 19.8854C32.125 20.6246 32.125 21.6372 32.125 22.9507V24.2854C32.125 29.3696 28.285 31.8072 26.0014 32.8047L25.9788 32.8146C25.6956 32.9383 25.4295 33.0546 25.1237 33.1329C24.8008 33.2155 24.4577 33.2509 24 33.2509C23.5423 33.2509 23.1992 33.2155 22.8763 33.1329C22.5705 33.0546 22.3044 32.9383 22.0212 32.8146L21.9986 32.8047C19.715 31.8072 15.875 29.3696 15.875 24.2854V22.9508C15.875 21.6374 15.875 20.6245 15.9152 19.8854C15.9355 19.5131 15.9669 19.1889 16.019 18.9186C16.0691 18.6586 16.1488 18.3885 16.303 18.1688C16.459 17.9466 16.6886 17.7808 16.9175 17.6479C17.1553 17.5098 17.4507 17.3746 17.7942 17.235C18.4762 16.958 19.4288 16.6319 20.6633 16.2093L21.2695 16.0018ZM24 16.5842C23.4519 16.5842 22.9126 16.7606 21.5672 17.2211L21.0898 17.3845C19.8293 17.816 18.9101 18.1309 18.2647 18.3931C17.9425 18.524 17.7091 18.6337 17.5452 18.7288C17.4644 18.7758 17.4086 18.8146 17.3714 18.8448C17.3398 18.8705 17.3278 18.885 17.3261 18.8871C17.3245 18.8898 17.3141 18.9071 17.2995 18.948C17.2829 18.9948 17.2644 19.0618 17.2464 19.1551C17.21 19.344 17.1825 19.6034 17.1634 19.9533C17.1252 20.6543 17.125 21.6328 17.125 22.9731V24.2854C17.125 28.5979 20.3499 30.7204 22.499 31.6592C22.8086 31.7944 22.9873 31.871 23.1863 31.9219C23.3764 31.9706 23.6083 32.0009 24 32.0009C24.3917 32.0009 24.6236 31.9706 24.8137 31.9219C25.0127 31.871 25.1914 31.7944 25.501 31.6592C27.6501 30.7204 30.875 28.5979 30.875 24.2854V22.9731C30.875 21.6328 30.8748 20.6543 30.8366 19.9533C30.8175 19.6034 30.79 19.344 30.7536 19.1551C30.7356 19.0618 30.7171 18.9948 30.7005 18.948C30.6859 18.907 30.6755 18.8897 30.6739 18.8871C30.6722 18.885 30.6601 18.8705 30.6286 18.8448C30.5914 18.8146 30.5356 18.7758 30.4548 18.7288C30.2909 18.6337 30.0575 18.524 29.7353 18.3931C29.0899 18.1309 28.1707 17.816 26.9102 17.3845L26.4328 17.2211C25.0874 16.7606 24.5481 16.5842 24 16.5842Z"
        fill="#284CB1"
      />
    </svg>
  );
};

export const SupportIcons = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 14.4596V10.293C17.5 6.15083 14.1421 2.79297 10 2.79297C5.85786 2.79297 2.5 6.15083 2.5 10.293V14.4596"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.3333 13.21V14.8766"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.66675 13.21V14.8766"
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.66667 11.8302C6.66667 11.1932 6.66667 10.8747 6.52105 10.6532C6.44778 10.5417 6.35051 10.4496 6.237 10.3842C6.01143 10.2542 5.70677 10.2843 5.09745 10.3444C4.07073 10.4456 3.55736 10.4962 3.18948 10.7733C3.00329 10.9136 2.84698 11.0924 2.73038 11.2986C2.5 11.7059 2.5 12.2426 2.5 13.316V14.6207C2.5 15.6834 2.5 16.2147 2.73498 16.6251C2.82293 16.7787 2.93317 16.9172 3.0618 17.0358C3.40544 17.3524 3.90703 17.4513 4.91023 17.6492C5.6162 17.7884 5.96918 17.858 6.2297 17.7114C6.32583 17.6573 6.4108 17.584 6.47977 17.4958C6.66667 17.2567 6.66667 16.8828 6.66667 16.1349V11.8302Z"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
      <path
        d="M13.3333 11.8302C13.3333 11.1932 13.3333 10.8747 13.4789 10.6532C13.5521 10.5417 13.6494 10.4496 13.7629 10.3842C13.9885 10.2542 14.2932 10.2843 14.9025 10.3444C15.9292 10.4456 16.4426 10.4962 16.8104 10.7733C16.9966 10.9136 17.1529 11.0924 17.2695 11.2986C17.4999 11.7059 17.4999 12.2426 17.4999 13.316V14.6207C17.4999 15.6834 17.4999 16.2147 17.2649 16.6251C17.177 16.7787 17.0667 16.9172 16.9381 17.0358C16.5945 17.3524 16.0929 17.4513 15.0897 17.6492C14.3837 17.7884 14.0307 17.858 13.7702 17.7114C13.6741 17.6573 13.5891 17.584 13.5202 17.4958C13.3333 17.2567 13.3333 16.8828 13.3333 16.1349V11.8302Z"
        stroke="CurrentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const SupportIconLarge = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fillOpacity="0.5" />
      <path
        d="M31.5 28.1667V24C31.5 19.8579 28.1421 16.5 24 16.5C19.8579 16.5 16.5 19.8579 16.5 24V28.1667"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
      <path
        d="M32.3333 26.917V28.5837"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.6667 26.917V28.5837"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M20.6667 25.5372C20.6667 24.9002 20.6667 24.5817 20.5211 24.3602C20.4478 24.2488 20.3505 24.1567 20.237 24.0913C20.0114 23.9613 19.7068 23.9913 19.0975 24.0514C18.0707 24.1526 17.5574 24.2032 17.1895 24.4804C17.0033 24.6206 16.847 24.7994 16.7304 25.0056C16.5 25.4129 16.5 25.9496 16.5 27.023V28.3277C16.5 29.3904 16.5 29.9218 16.735 30.3321C16.8229 30.4857 16.9332 30.6242 17.0618 30.7428C17.4054 31.0595 17.907 31.1584 18.9102 31.3562C19.6162 31.4954 19.9692 31.565 20.2297 31.4184C20.3258 31.3643 20.4108 31.2911 20.4798 31.2028C20.6667 30.9637 20.6667 30.5898 20.6667 29.842V25.5372Z"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
      <path
        d="M27.3333 25.5372C27.3333 24.9002 27.3333 24.5817 27.4789 24.3602C27.5521 24.2488 27.6494 24.1567 27.7629 24.0913C27.9885 23.9613 28.2932 23.9913 28.9025 24.0514C29.9292 24.1526 30.4426 24.2032 30.8104 24.4804C30.9966 24.6206 31.1529 24.7994 31.2695 25.0056C31.4999 25.4129 31.4999 25.9496 31.4999 27.023V28.3277C31.4999 29.3904 31.4999 29.9218 31.2649 30.3321C31.177 30.4857 31.0667 30.6242 30.9381 30.7428C30.5945 31.0595 30.0929 31.1584 29.0897 31.3562C28.3837 31.4954 28.0307 31.565 27.7702 31.4184C27.6741 31.3643 27.5891 31.2911 27.5202 31.2028C27.3333 30.9637 27.3333 30.5898 27.3333 29.842V25.5372Z"
        stroke="#284CB1"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 14.4596V16.443C10.0001 18.0013 9.37508 18.6263 7.80841 18.6263H3.85008C2.29175 18.6263 1.66675 18.0013 1.66675 16.443V12.4846C1.66675 10.918 2.29175 10.293 3.85008 10.293H5.83341V12.268C5.83341 13.8346 6.45841 14.4596 8.01675 14.4596H10.0001Z"
        stroke="#BDBDBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 10.2926V12.2676C14.1666 13.8343 13.5416 14.4593 11.9749 14.4593H8.01659C6.45825 14.4593 5.83325 13.8343 5.83325 12.2676V8.30931C5.83325 6.75098 6.45825 6.12598 8.01659 6.12598H9.99992V8.10098C9.99992 9.66764 10.6249 10.2926 12.1833 10.2926H14.1666Z"
        stroke="#BDBDBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 4.14329V8.10163C18.3333 9.66829 17.7083 10.2933 16.1417 10.2933H12.1833C10.625 10.2933 10 9.66829 10 8.10163V4.14329C10 2.58496 10.625 1.95996 12.1833 1.95996H16.1417C17.7083 1.95996 18.3333 2.58496 18.3333 4.14329Z"
        stroke="#BDBDBD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIconLarge = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#D9D6FF" fill-opacity="0.5" />
      <path
        d="M24.0001 28.4596V30.443C24.0001 32.0013 23.3751 32.6263 21.8084 32.6263H17.8501C16.2917 32.6263 15.6667 32.0013 15.6667 30.443V26.4846C15.6667 24.918 16.2917 24.293 17.8501 24.293H19.8334V26.268C19.8334 27.8346 20.4584 28.4596 22.0167 28.4596H24.0001Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1666 24.2931V26.2681C28.1666 27.8348 27.5416 28.4598 25.9749 28.4598H22.0166C20.4583 28.4598 19.8333 27.8348 19.8333 26.2681V22.3098C19.8333 20.7515 20.4583 20.1265 22.0166 20.1265H23.9999V22.1015C23.9999 23.6681 24.6249 24.2931 26.1833 24.2931H28.1666Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3333 18.1428V22.1011C32.3333 23.6678 31.7083 24.2928 30.1417 24.2928H26.1833C24.625 24.2928 24 23.6678 24 22.1011V18.1428C24 16.5845 24.625 15.9595 26.1833 15.9595H30.1417C31.7083 15.9595 32.3333 16.5845 32.3333 18.1428Z"
        stroke="#284CB1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GalleryIcon = () => {
  return (
    <svg width="25" style={{cursor: 'pointer'}} height="24" viewBox="0 0 25 24" fill="CurrentColor" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12.5508 1.25H12.6655C14.9739 1.24999 16.783 1.24998 18.1945 1.43975C19.6392 1.63399 20.7792 2.03933 21.674 2.93414C22.5688 3.82895 22.9742 4.96897 23.1684 6.41371C23.3582 7.82519 23.3582 9.63423 23.3582 11.9426V12.0574C23.3582 12.5023 23.3582 12.9287 23.3568 13.3372C23.3588 13.3696 23.3587 13.4025 23.3564 13.4356C23.3499 15.1021 23.3187 16.4688 23.1684 17.5863C22.9742 19.031 22.5688 20.1711 21.674 21.0659C20.7792 21.9607 19.6392 22.366 18.1945 22.5603C17.4567 22.6594 16.6103 22.7068 15.6408 22.7294C15.5488 22.7515 15.4511 22.7566 15.3518 22.7414C15.3413 22.7398 15.3308 22.7379 15.3205 22.7359C14.5188 22.75 13.6363 22.75 12.6655 22.75H12.5508C10.2424 22.75 8.43335 22.75 7.02186 22.5603C5.57712 22.366 4.4371 21.9607 3.54229 21.0659C2.64748 20.1711 2.24214 19.031 2.0479 17.5863C1.85813 16.1748 1.85814 14.3658 1.85815 12.0574V11.9426C1.85815 11.3365 1.85815 10.7647 1.86158 10.2256C1.85647 10.1729 1.85699 10.1208 1.86268 10.07C1.87388 8.62518 1.91279 7.41868 2.0479 6.41371C2.24214 4.96897 2.64748 3.82895 3.54229 2.93414C4.4371 2.03933 5.57712 1.63399 7.02186 1.43975C8.43335 1.24998 10.2424 1.24999 12.5508 1.25ZM3.35924 10.8037C3.3582 11.1826 3.35816 11.5809 3.35816 12C3.35816 14.3782 3.35975 16.0864 3.53453 17.3864C3.7064 18.6648 4.0333 19.4355 4.60295 20.0052C5.17261 20.5749 5.94333 20.9018 7.22173 21.0736C8.52171 21.2484 10.2299 21.25 12.6082 21.25C13.4125 21.25 14.1402 21.2498 14.8014 21.2428C15.3442 15.0501 9.95956 9.85595 3.69549 10.7554L3.35924 10.8037ZM16.3092 21.2078C16.9405 21.182 17.4974 21.1405 17.9946 21.0736C19.273 20.9018 20.0437 20.5749 20.6134 20.0052C21.183 19.4355 21.5099 18.6648 21.6818 17.3864C21.8021 16.4918 21.8403 15.4038 21.8525 14.0371L21.5318 13.9927C19.1124 13.6577 16.9118 14.7947 15.6928 16.636C16.1993 18.0541 16.427 19.6005 16.3092 21.2078ZM14.9956 15.0736C12.8539 11.1169 8.4033 8.56403 3.48229 9.27064L3.37262 9.28639C3.39145 8.2301 3.43479 7.35537 3.53453 6.61358C3.7064 5.33517 4.0333 4.56445 4.60295 3.9948C5.17261 3.42514 5.94333 3.09825 7.22173 2.92637C8.52171 2.75159 10.2299 2.75 12.6082 2.75C14.9864 2.75 16.6946 2.75159 17.9946 2.92637C19.273 3.09825 20.0437 3.42514 20.6134 3.9948C21.183 4.56445 21.5099 5.33517 21.6818 6.61358C21.8566 7.91356 21.8582 9.62177 21.8582 12C21.8582 12.1783 21.8581 12.3528 21.8581 12.5236L21.7376 12.5069C19.0482 12.1345 16.5779 13.22 14.9956 15.0736ZM16.6082 6.75C15.9178 6.75 15.3582 7.30964 15.3582 8C15.3582 8.69036 15.9178 9.25 16.6082 9.25C17.2985 9.25 17.8582 8.69036 17.8582 8C17.8582 7.30964 17.2985 6.75 16.6082 6.75ZM13.8582 8C13.8582 6.48122 15.0894 5.25 16.6082 5.25C18.1269 5.25 19.3582 6.48122 19.3582 8C19.3582 9.51878 18.1269 10.75 16.6082 10.75C15.0894 10.75 13.8582 9.51878 13.8582 8Z" fill="#BDBDBD"/>
</svg>

  )
}

export const LinkIcon = () => {
  return (
    <svg width="25" style={{cursor: 'pointer'}} height="24" viewBox="0 0 25 24" fill="#BDBDBD" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M9.49373 3.36262C12.4365 0.545795 17.1945 0.545795 20.1372 3.36262C23.0985 6.19714 23.0985 10.807 20.1372 13.6415L12.1892 21.2495C10.0991 23.2502 6.72347 23.2502 4.63341 21.2495C2.52485 19.2312 2.52485 15.9446 4.63341 13.9263L12.4671 6.42771C13.7045 5.24324 15.6977 5.24325 16.9351 6.42771C18.1911 7.62989 18.1911 9.59316 16.9351 10.7953L9.04427 18.3486C8.74505 18.635 8.27029 18.6247 7.98386 18.3254C7.69744 18.0262 7.70782 17.5515 8.00704 17.265L15.8979 9.71175C16.5368 9.10021 16.5368 8.12285 15.8979 7.5113C15.2405 6.88205 14.1617 6.88205 13.5043 7.5113L5.67064 15.0098C4.1791 16.4376 4.1791 18.7382 5.67064 20.1659C7.18067 21.6114 9.64193 21.6114 11.152 20.1659L19.1 12.5579C21.4442 10.314 21.4442 6.6901 19.1 4.4462C16.7373 2.1846 12.8936 2.1846 10.531 4.4462L4.12677 10.5764C3.82754 10.8628 3.35278 10.8524 3.06636 10.5532C2.77994 10.254 2.79032 9.77924 3.08954 9.49281L9.49373 3.36262Z" fill="BDBDBD"/>
</svg>

  )
}
 
export const SendIcon = () => {
  return (
    <svg width="37" style={{cursor: 'pointer'}} height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M31.1363 15.7812L28.5617 23.5052C26.7464 28.9511 25.8387 31.6741 24.5077 32.4479C23.2415 33.184 21.6776 33.184 20.4114 32.4479C19.0804 31.6741 18.1727 28.9511 16.3574 23.5052C16.0659 22.6308 15.9202 22.1936 15.6756 21.8281C15.4385 21.4739 15.1342 21.1697 14.7801 20.9326C14.4146 20.688 13.9774 20.5422 13.103 20.2507C7.65701 18.4354 4.93403 17.5278 4.16024 16.1967C3.42412 14.9305 3.42413 13.3667 4.16024 12.1005C4.93403 10.7695 7.65701 9.8618 13.103 8.04648L20.827 5.47181C27.5745 3.22262 30.9483 2.09803 32.7292 3.87893C34.5101 5.65983 33.3855 9.03362 31.1363 15.7812ZM20.1767 16.3533C19.7398 15.9115 19.7437 15.1992 20.1855 14.7623L26.5013 8.51613C26.9431 8.07923 27.6554 8.08318 28.0923 8.52494C28.5292 8.96671 28.5252 9.67901 28.0834 10.1159L21.7676 16.3621C21.3259 16.799 20.6136 16.795 20.1767 16.3533Z" fill="#1C274C"/>
</svg>

  )
}

export const StarIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25591 11.5272L12.3759 14.0138L11.2826 9.32717L14.9226 6.17383L10.1292 5.76717L8.25591 1.34717L6.38258 5.76717L1.58925 6.17383L5.22925 9.32717L4.13592 14.0138L8.25591 11.5272Z" fill="#284CB1"/>
</svg>

  )
}

export const MobileIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.58333 14.2935H11.4167C11.7388 14.2935 12 13.7462 12 13.0712L12 4.51568C12 3.84066 11.7388 3.29346 11.4167 3.29346H5.58333C5.26117 3.29346 5 3.84066 5 4.51568L5 13.0712C5 13.7462 5.26117 14.2935 5.58333 14.2935Z" stroke="#8F8F8F" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5 12.2935H12" stroke="#8F8F8F" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}